import { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabase'
import { TRANSPORT_OPTIONS } from '../../lib/transportation'

/**
 * Transportation chips, plus a team-member dropdown when "Family member" is
 * picked. Shared by the full appointment form and the FAB quick-add so the two
 * write an identical shape.
 */
export default function TransportationField({
  recipientId,
  value,
  assignedName,
  onChange,
}) {
  const [family, setFamily] = useState([])

  useEffect(() => {
    if (value !== 'family' || !recipientId) return
    let active = true
    ;(async () => {
      const { data } = await supabase
        .from('care_team_members')
        .select('id, invited_name, relationship, profile:profiles(full_name)')
        .eq('care_recipient_id', recipientId)
        .eq('role', 'family_member')
        .eq('is_active', true)
      if (active) setFamily(data || [])
    })()
    return () => { active = false }
  }, [value, recipientId])

  const nameOf = (m) =>
    m.profile?.full_name || m.invited_name || m.relationship || 'Family member'

  return (
    <div className="field">
      <span className="label">Transportation</span>
      <div className="row wrap" style={{ gap: 8 }}>
        {TRANSPORT_OPTIONS.map((o) => (
          <button
            key={o.value}
            type="button"
            className={`chip${value === o.value ? ' chip-on' : ''}`}
            aria-pressed={value === o.value}
            onClick={() =>
              onChange(
                value === o.value ? null : o.value,
                // Dropping or switching away from Family clears the person.
                value === o.value || o.value !== 'family' ? null : assignedName
              )
            }
          >
            {o.label}
          </button>
        ))}
      </div>

      {value === 'family' && (
        <div style={{ marginTop: 8 }}>
          {family.length === 0 ? (
            <p className="muted" style={{ fontSize: 13, margin: 0 }}>
              No family members on the care team yet — add one from the Team screen.
            </p>
          ) : (
            <select
              className="select"
              value={assignedName || ''}
              onChange={(e) => onChange('family', e.target.value || null)}
              aria-label="Which family member is driving?"
            >
              <option value="">Who's taking them?</option>
              {family.map((m) => (
                <option key={m.id} value={nameOf(m)}>{nameOf(m)}</option>
              ))}
            </select>
          )}
        </div>
      )}
    </div>
  )
}
